export default {
  'Resolution': '解像度',
  'Frame rate': 'フレームレート',
  'The higher the frame rate, the smoother the animation': 'フレームレートが高いほど、アニメーションが滑らかになります。',
}